import { styled } from "@linaria/react";
export const SearchWrapper = /*#__PURE__*/styled('div')({
  name: "SearchWrapper",
  class: "gdg-seveqep",
  propsAsIs: false
});

